module.exports = __webpack_public_path__ + "static/media/microphone.27c1a866.jpg";